module.exports = {
	"ha": "vcha",
	"id": 5.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category and MSM Status, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 92.6829268292683,
						"dataLabels": {
							"enabled": false,
							"format": "76"
						},
						"color": "#043f61"
					},
					{
						"y": 90.2439024390244,
						"dataLabels": {
							"enabled": false,
							"format": "74"
						},
						"color": "#0c4250"
					},
					{
						"y": 87.8048780487805,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.04878048780488,
						"dataLabels": {
							"enabled": false,
							"format": "64"
						},
						"color": "#09472e"
					},
					{
						"y": 64.63414634146342,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.61022364217251,
						"dataLabels": {
							"enabled": false,
							"format": "293"
						},
						"color": "#043f61"
					},
					{
						"y": 82.42811501597444,
						"dataLabels": {
							"enabled": false,
							"format": "258"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.55271565495208,
						"dataLabels": {
							"enabled": false,
							"format": "249"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.92651757188499,
						"dataLabels": {
							"enabled": false,
							"format": "222"
						},
						"color": "#09472e"
					},
					{
						"y": 61.0223642172524,
						"dataLabels": {
							"enabled": false,
							"format": "191"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.55907780979827,
						"dataLabels": {
							"enabled": false,
							"format": "342"
						},
						"color": "#043f61"
					},
					{
						"y": 91.06628242074927,
						"dataLabels": {
							"enabled": false,
							"format": "316"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.47262247838617,
						"dataLabels": {
							"enabled": false,
							"format": "307"
						},
						"color": "#0d4440"
					},
					{
						"y": 82.9971181556196,
						"dataLabels": {
							"enabled": false,
							"format": "288"
						},
						"color": "#09472e"
					},
					{
						"y": 67.14697406340058,
						"dataLabels": {
							"enabled": false,
							"format": "233"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.92952783650459,
						"dataLabels": {
							"enabled": false,
							"format": "1418"
						},
						"color": "#043f61"
					},
					{
						"y": 95.34883720930233,
						"dataLabels": {
							"enabled": false,
							"format": "1353"
						},
						"color": "#0c4250"
					},
					{
						"y": 92.74136715997182,
						"dataLabels": {
							"enabled": false,
							"format": "1316"
						},
						"color": "#0d4440"
					},
					{
						"y": 89.07681465821,
						"dataLabels": {
							"enabled": false,
							"format": "1264"
						},
						"color": "#09472e"
					},
					{
						"y": 76.95560253699789,
						"dataLabels": {
							"enabled": false,
							"format": "1092"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.94736842105263,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#09472e"
					},
					{
						"y": 36.84210526315789,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.14814814814815,
						"dataLabels": {
							"enabled": false,
							"format": "106"
						},
						"color": "#043f61"
					},
					{
						"y": 96.29629629629629,
						"dataLabels": {
							"enabled": false,
							"format": "104"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.74074074074075,
						"dataLabels": {
							"enabled": false,
							"format": "98"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.70370370370371,
						"dataLabels": {
							"enabled": false,
							"format": "85"
						},
						"color": "#09472e"
					},
					{
						"y": 50.92592592592593,
						"dataLabels": {
							"enabled": false,
							"format": "55"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.54128440366972,
						"dataLabels": {
							"enabled": false,
							"format": "217"
						},
						"color": "#043f61"
					},
					{
						"y": 96.78899082568807,
						"dataLabels": {
							"enabled": false,
							"format": "211"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.11926605504587,
						"dataLabels": {
							"enabled": false,
							"format": "203"
						},
						"color": "#0d4440"
					},
					{
						"y": 82.56880733944955,
						"dataLabels": {
							"enabled": false,
							"format": "180"
						},
						"color": "#09472e"
					},
					{
						"y": 55.96330275229357,
						"dataLabels": {
							"enabled": false,
							"format": "122"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.12023460410558,
						"dataLabels": {
							"enabled": false,
							"format": "676"
						},
						"color": "#043f61"
					},
					{
						"y": 99.12023460410558,
						"dataLabels": {
							"enabled": false,
							"format": "676"
						},
						"color": "#0c4250"
					},
					{
						"y": 95.60117302052787,
						"dataLabels": {
							"enabled": false,
							"format": "652"
						},
						"color": "#0d4440"
					},
					{
						"y": 88.85630498533725,
						"dataLabels": {
							"enabled": false,
							"format": "606"
						},
						"color": "#09472e"
					},
					{
						"y": 65.24926686217009,
						"dataLabels": {
							"enabled": false,
							"format": "445"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 39.77272727272727,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#043f61"
					},
					{
						"y": 35.22727272727273,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0c4250"
					},
					{
						"y": 32.95454545454545,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0d4440"
					},
					{
						"y": 28.40909090909091,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#09472e"
					},
					{
						"y": 15.909090909090908,
						"dataLabels": {
							"enabled": false,
							"format": "14"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 92.15686274509804,
						"dataLabels": {
							"enabled": false,
							"format": "141"
						},
						"color": "#043f61"
					},
					{
						"y": 83.00653594771242,
						"dataLabels": {
							"enabled": false,
							"format": "127"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.08496732026144,
						"dataLabels": {
							"enabled": false,
							"format": "121"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.8562091503268,
						"dataLabels": {
							"enabled": false,
							"format": "113"
						},
						"color": "#09472e"
					},
					{
						"y": 60.78431372549019,
						"dataLabels": {
							"enabled": false,
							"format": "93"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.41434262948208,
						"dataLabels": {
							"enabled": false,
							"format": "242"
						},
						"color": "#043f61"
					},
					{
						"y": 81.27490039840637,
						"dataLabels": {
							"enabled": false,
							"format": "204"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.6812749003984,
						"dataLabels": {
							"enabled": false,
							"format": "200"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.90836653386454,
						"dataLabels": {
							"enabled": false,
							"format": "183"
						},
						"color": "#09472e"
					},
					{
						"y": 59.36254980079681,
						"dataLabels": {
							"enabled": false,
							"format": "149"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.74726609963548,
						"dataLabels": {
							"enabled": false,
							"format": "788"
						},
						"color": "#043f61"
					},
					{
						"y": 73.39003645200486,
						"dataLabels": {
							"enabled": false,
							"format": "604"
						},
						"color": "#0c4250"
					},
					{
						"y": 71.5674362089915,
						"dataLabels": {
							"enabled": false,
							"format": "589"
						},
						"color": "#0d4440"
					},
					{
						"y": 69.01579586877278,
						"dataLabels": {
							"enabled": false,
							"format": "568"
						},
						"color": "#09472e"
					},
					{
						"y": 58.80923450789793,
						"dataLabels": {
							"enabled": false,
							"format": "484"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -7.317073170731703,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.631578947368418,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.7027027027026973,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.1875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.389776357827481,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.945392491467576,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.488372093023251,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.843373493975905,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.963963963963966,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.4409221902017322,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.602339181286554,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.848101265822789,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.1889250814332275,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.09722222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.0704721634954164,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.583921015514814,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.734663710273466,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.951367781155013,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.607594936708855,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.052631578947366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -53.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.851851851851849,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.8867924528301883,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.769230769230771,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.265306122448983,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.29411764705882,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.4587155963302725,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.7649769585253448,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.791469194312791,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.33004926108374,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -32.22222222222222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.8797653958944274,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.5502958579881616,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.055214723926384,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.567656765676574,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -60.22727272727273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.428571428571432,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.793103448275868,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -43.99999999999999,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -7.843137254901967,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.9290780141844,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.7244094488189,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.6115702479338845,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.699115044247794,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.585657370517925,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.702479338842979,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.9607843137254943,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.499999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.579234972677593,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.252733900364525,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.350253807106604,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.4834437086092676,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.5653650254668934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.7887323943662,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=82"
			},
			{
				"x": 9,
				"text": "30-39<br>n=313"
			},
			{
				"x": 15,
				"text": "40-49<br>n=347"
			},
			{
				"x": 21,
				"text": ">=50<br>n=1419"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=19"
			},
			{
				"x": 34,
				"text": "30-39<br>n=108"
			},
			{
				"x": 40,
				"text": "40-49<br>n=218"
			},
			{
				"x": 46,
				"text": ">=50<br>n=682"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=88"
			},
			{
				"x": 59,
				"text": "30-39<br>n=153"
			},
			{
				"x": 65,
				"text": "40-49<br>n=251"
			},
			{
				"x": 71,
				"text": ">=50<br>n=823"
			}
		],
		"dataTable": {
			"MSM:<30": [
				82,
				76,
				74,
				72,
				64,
				53
			],
			"MSM:30-39": [
				313,
				293,
				258,
				249,
				222,
				191
			],
			"MSM:40-49": [
				347,
				342,
				316,
				307,
				288,
				233
			],
			"MSM:>=50": [
				1419,
				1418,
				1353,
				1316,
				1264,
				1092
			],
			"Non-MSM:<30": [
				19,
				19,
				19,
				19,
				15,
				7
			],
			"Non-MSM:30-39": [
				108,
				106,
				104,
				98,
				85,
				55
			],
			"Non-MSM:40-49": [
				218,
				217,
				211,
				203,
				180,
				122
			],
			"Non-MSM:>=50": [
				682,
				676,
				676,
				652,
				606,
				445
			],
			"Unknown:<30": [
				88,
				35,
				31,
				29,
				25,
				14
			],
			"Unknown:30-39": [
				153,
				141,
				127,
				121,
				113,
				93
			],
			"Unknown:40-49": [
				251,
				242,
				204,
				200,
				183,
				149
			],
			"Unknown:>=50": [
				823,
				788,
				604,
				589,
				568,
				484
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_5.json
// module id = 306
// module chunks = 0